import image from "assets/img/sign.jpg";

const loginStyle = theme => ({
    page: {
        minHeight: "100vh",
        position: "relative",
        background: "#eef2f7",
        color: "#263a59",
        overflow: "hidden",
    },
    hero: {
        position: "relative",
        height: "385px",
        margin: "48px 10px 0",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundImage: "url(" + image + ")",
        backgroundPosition: "center 56%",
        backgroundSize: "cover",
        [theme.breakpoints.down("sm")]: {
            height: "340px",
            marginTop: "24px",
        },
    },
    heroOverlay: {
        position: "absolute",
        inset: 0,
        background: "rgba(8, 20, 34, 0.54)",
    },
    brandWrap: {
        position: "relative",
        zIndex: 1,
        width: "80%",
        maxWidth: "1140px",
        minWidth: "720px",
        margin: "0 auto",
        paddingTop: "22px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 32px)",
            minWidth: "unset",
        },
    },
    logo: {
        width: "76px",
        height: "40px",
        objectFit: "contain",
        background: "#fff",
    },
    logoLink: {
        display: "inline-flex",
        lineHeight: 0,
        cursor: "pointer",
    },
    brandText: {
        fontSize: "13px",
        fontWeight: 700,
        color: "#fff",
    },
    loginShell: {
        position: "relative",
        zIndex: 2,
        width: "344px",
        margin: "-108px auto 0",
        borderRadius: "8px",
        background: "#fff",
        boxShadow: "0 2px 8px rgba(18, 38, 63, 0.16)",
        [theme.breakpoints.down("xs")]: {
            width: "calc(100% - 32px)",
        },
    },
    form: {
        margin: 0,
    },
    cardHeader: {
        width: "calc(100% - 28px)",
        margin: "0 auto",
        transform: "translateY(-21px)",
        padding: "30px 16px 28px",
        borderRadius: "7px",
        color: "#fff",
        textAlign: "center",
        background: "linear-gradient(180deg, #3499f2 0%, #287de5 100%)",
        boxShadow: "0 8px 16px rgba(42, 139, 230, 0.28)",
        "& h1": {
            margin: 0,
            fontSize: "23px",
            lineHeight: 1.2,
            fontWeight: 700,
            letterSpacing: 0,
        },
        "& p": {
            margin: "12px 0 0",
            fontSize: "12px",
            lineHeight: 1.4,
            color: "rgba(255,255,255,0.90)",
        },
    },
    cardBody: {
        marginTop: "-3px",
        padding: "0 22px 30px",
        "& .MuiFormControl-root": {
            margin: "0 0 4px",
            paddingTop: 0,
        },
        "& label": {
            color: "#7f8ba8 !important",
            fontSize: "11px",
        },
        "& input": {
            height: "34px",
            color: "#243b5a",
            fontSize: "13px",
        },
    },
    signInButton: {
        width: "100%",
        height: "36px",
        margin: "22px 0 18px !important",
        padding: "0 !important",
        borderRadius: "6px !important",
        background: "#2f8de9 !important",
        color: "#fff !important",
        fontSize: "10px !important",
        fontWeight: "700 !important",
        boxShadow: "0 4px 10px rgba(42, 139, 230, 0.34) !important",
        "&:hover,&:focus": {
            background: "#247bd0 !important",
            color: "#fff !important",
        },
    },
    resetText: {
        textAlign: "center",
        color: "#8b97b4",
        fontSize: "12px",
        "& button": {
            border: 0,
            padding: 0,
            background: "transparent",
            color: "#2585e8",
            fontWeight: 700,
            cursor: "pointer",
        },
    },
    inputIconsColor: {
        color: "#6f7480",
    },
    errorContainer: {
        color: "#d32f2f",
        minHeight: "22px",
        fontSize: "12px",
        textAlign: "center",
    },
    footer: {
        position: "absolute",
        left: "10%",
        bottom: "18px",
        color: "#7181a8",
        fontSize: "12px",
        "& span": {
            color: "#6f7788",
        },
        "& strong": {
            color: "#243b5a",
        },
        [theme.breakpoints.down("sm")]: {
            position: "static",
            margin: "60px 24px 20px",
            textAlign: "center",
        },
    },
});

export default loginStyle;
